var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#82AFFF"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M274.43,311.874c-30.237,0-54.765-24.528-54.765-54.793c0-30.209,24.528-54.792,54.765-54.792   c11.25,0,21.625,3.46,30.27,9.316c1.324,0.897,2.835-0.843,1.726-1.996c-12.921-13.434-31.209-21.63-51.486-20.938   c-34.836,1.189-63.675,29.119-65.901,63.904c-2.55,39.844,28.999,72.956,68.279,72.956c19.349,0,36.738-8.089,49.156-21.022   c1.097-1.143-0.417-2.856-1.729-1.967C296.092,308.41,285.7,311.874,274.43,311.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M322.375,223.354l5.682,15.977l15.315-7.28c1.154-0.548,2.357,0.655,1.809,1.809l-7.28,15.315   l15.977,5.682c1.203,0.428,1.203,2.13,0,2.558l-15.977,5.682l7.28,15.315c0.548,1.154-0.655,2.357-1.809,1.809l-15.315-7.28   l-5.682,15.977c-0.428,1.203-2.13,1.203-2.558,0l-5.682-15.977l-15.315,7.28c-1.154,0.548-2.357-0.655-1.809-1.809l7.28-15.315   l-15.977-5.682c-1.203-0.428-1.203-2.13,0-2.558l15.977-5.682l-7.28-15.315c-0.548-1.154,0.655-2.357,1.809-1.809l15.315,7.28   l5.682-15.977C320.245,222.15,321.947,222.15,322.375,223.354z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/az.0ea3a97ce31e0b5c9592bbcd6da8c660.svg";
export { ForwardRef as ReactComponent };